import EmergencyNav from "../../pages/Dashboard/Emergency/EmergencyNav";
import EmergencyList from "../../pages/Dashboard/Emergency/EmergencyList";
import EmergencyCreate from "../../pages/Dashboard/Emergency/EmergencyCreate";
import EmergencyView from "../../pages/Dashboard/Emergency/EmergencyView";

const emergencyRoutes = {
  path: "/emergency",
  element: <EmergencyNav />,
  children: [
    { path: "/emergency", element: <EmergencyList /> },
    { path: "/emergency/new", element: <EmergencyCreate /> },
    { path: "/emergency/:id", element: <EmergencyView /> },
  ],
};

export default emergencyRoutes;
